export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    height: {
      type: [Number],
      default: 300
    },
    customStyle: {
      type: Object,
      default: () => {
        return {};
      }
    },
    showTip: {
      type: Boolean,
      default: false
    },
    tip: {
      type: String,
      default: '这是提示内容'
    },
    tipEffect: {
      type: String,
      default: 'dark'
    },
    tipPlacement: {
      type: String,
      default: 'top'
    },
    renderer: {
      type: String,
      default: "svg"
    }
  },
  computed: {
    chartStyle() {
      return Object.assign({}, {
        height: `${this.height}px`
      }, this.customStyle);
    },

    initOptions() {
      var _this$renderer;

      return {
        renderer: (_this$renderer = this.renderer) !== null && _this$renderer !== void 0 ? _this$renderer : 'svg'
      };
    },

    isShowTitle() {
      return this.title && this.showTitle;
    }

  }
};